// MfaAuthSelectPanel.js
import React, { useState, useEffect } from 'react';
import styles from '../../MfaPage.module.css'; 
import { DialogEnum, showDialog } from '../../../../utils/dialog/Dialog';
import axios from "../../../../utils/api/axios";
import { InnocodeButton } from '@intsoft/innocode-core';


function MfaSuccessPanel({ onNext }) {
    return (
        <div className={styles.success_container}>
            <div className={styles.success_content}>
                <div className={styles.success_icon_wrapper}>
                    <div className={styles.success_icon_container}>
                        <span className={`material-symbols-outlined ${styles.check_success_icon}`}>check</span>
                    </div>
                    <div className={`innocode-typography--title-sm innocode-typography--bold ${styles.success_title}`}>인증 완료</div>
                </div>
                <div className={`innocode-typography--body-md-reading innocode-typography--medium ${styles.success_description}`}>
                    인증이 완료되었습니다.<br className={styles.mobile_only}/>
                </div>
            </div>
            <div className={styles.submit_btn_container}> 
                <InnocodeButton size="lg" onClick={onNext} className={styles.confirm_button}>
                    확인
                </InnocodeButton>
            </div>
        </div>
    );
}

export default MfaSuccessPanel;
